module.exports = __webpack_public_path__ + "img/exhausted.6076a8d0.png";